
export default function DocumentFolder(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="2em"
      height="2em"
      {...props}
    >
      <g fill="none">
        <path
          fill="url(#fluentColorDocumentFolder160)"
          d="M5 5.5A1.5 1.5 0 0 1 6.5 4h5A1.5 1.5 0 0 1 13 5.5v5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 5 10.5z"
        ></path>
        <path
          fill="url(#fluentColorDocumentFolder161)"
          d="M5 5.5A1.5 1.5 0 0 1 6.5 4h5A1.5 1.5 0 0 1 13 5.5v5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 5 10.5z"
        ></path>
        <path
          fill="url(#fluentColorDocumentFolder163)"
          d="M3 3.5A1.5 1.5 0 0 1 4.5 2h5A1.5 1.5 0 0 1 11 3.5v7A1.5 1.5 0 0 1 9.5 12h-5A1.5 1.5 0 0 1 3 10.5z"
        ></path>
        <path
          fill="url(#fluentColorDocumentFolder162)"
          d="M3.5 5A1.5 1.5 0 0 0 2 6.5V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-.5a1.5 1.5 0 0 0-1.5-1.5h-1.586a.5.5 0 0 1-.353-.146L6.146 5.439A1.5 1.5 0 0 0 5.086 5z"
        ></path>
        <defs>
          <linearGradient
            id="fluentColorDocumentFolder160"
            x1="14.2"
            x2="15.247"
            y1="13.539"
            y2="5.069"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BB45EA"></stop>
            <stop offset="1" stopColor="#9C6CFE"></stop>
          </linearGradient>
          <linearGradient
            id="fluentColorDocumentFolder161"
            x1="13"
            x2="11"
            y1="6.769"
            y2="6.769"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".338" stopColor="#5750E2" stopOpacity="0"></stop>
            <stop offset="1" stopColor="#5750E2"></stop>
          </linearGradient>
          <linearGradient
            id="fluentColorDocumentFolder162"
            x1="4.571"
            x2="4.571"
            y1="5"
            y2="17.273"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".241" stopColor="#FFD638"></stop>
            <stop offset=".637" stopColor="#FAB500"></stop>
            <stop offset=".985" stopColor="#CA6407"></stop>
          </linearGradient>
          <radialGradient
            id="fluentColorDocumentFolder163"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(5.2 -7.66667 11.90405 8.07405 5.4 10)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".228" stopColor="#2764E7"></stop>
            <stop offset=".685" stopColor="#5CD1FF"></stop>
            <stop offset="1" stopColor="#6CE0FF"></stop>
          </radialGradient>
        </defs>
      </g>
    </svg>
  )
}